import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientCreateProviderPricePage } from "../ingredient-create-provider-price/ingredient-create-provider-price";
import { ProvidersServices } from "../../../providers/services";
import { Globals } from "../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { AdsServices } from '../../../ads/services';
import * as firebase from 'firebase';
import { IngredientsServices } from '../../services';
import { StockListPage } from '../../../stock/stock-list/stock-list';

/**
 * Generated class for the IngredientCreateSelectProviderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-create-select-provider',
  templateUrl: 'ingredient-create-select-provider.html',
})
export class IngredientCreateSelectProviderPage {

  firestore: any;
  update_state: boolean = false;
  dish_uid: string;
  ingredient_uid: string;
  providers: any;
  ingredient_measurement: any;
  ingredients: any;
  ingredient_name: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public providersServices: ProvidersServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public adsServices: AdsServices,
    private alertCtrl: AlertController,
    public ingredientServices: IngredientsServices,) {

    this.firestore = firebase.firestore();

    //this.dish_uid = this.navParams.get('dish_uid');
    this.update_state = this.navParams.get('update_state');
    this.ingredient_uid = this.navParams.get('ingredient_uid');
    this.ingredients = this.navParams.get('ingredients');
    this.ingredient_measurement = this.navParams.get('ingredient_measurement');
    this.ingredient_name = this.navParams.get('ingredient_name');
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.ingredientServices.show_alert_delete && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.ingredientServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }
  async openIngredientProviderPrice() {
    this.ingredientServices.show_alert_delete = false;
    var pred = false;
    if (this.providersServices.providers_array_tmp.length > 0) {

      if (this.update_state) {
        this.globals.GAtrackView('Ingredients', 'Ingredients - Select providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update select providers', 'Ingredients', this.ingredient_name);
      } else {
        this.globals.GAtrackView('Ingredients', 'Ingredients - Select providers - Create', this.globals.restaurant.email, 'Create/Update', 'Create select providers', 'Ingredients', this.ingredient_name);
      }


      for (let provider of this.providersServices.providers_array_tmp) {
        //Si el proveedor viene de ads
        if (provider.ads_provider_uid) {
          //Buscamos si este proveedor ya esta añadido
          await this.adsServices.searchProvider(provider);
          //Si no esta añadido lo añadimos a proveedores
          if (!this.adsServices.provider_exist) {
            await this.adsServices.addProvider(provider);
          }
        }
        if (provider[10] == true) {
          var extra = {
            "ingredient_name": this.ingredient_name,
            "email": provider[8],
            "address": provider[3],
            "nif": provider[2],
          };
          this.globals.dataSet('ingredient_provider', provider[1], '', JSON.stringify(extra));
          //
          pred = true;
          this.navCtrl.push(IngredientCreateProviderPricePage, {
            ingredient_measurement: this.ingredient_measurement,
            providers: this.providers,
            ingredient_uid: this.ingredient_uid,
            update_state: this.update_state,
            ingredient_name: this.ingredient_name

          })

        }
      }

      if (pred == false) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-selecciona-proveedor-predeterminado'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }


    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-selecciona-proveedor'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
  async ionViewWillEnter() {
    this.providersServices.getPagesProvider(false);

    if (this.update_state) {
      if (this.ingredients != null) {
        if (Object.keys(this.ingredients).length > 0) {
          this.providersServices.providers_array_tmp = Array(); //Reiniciamos array para no tener los antiguos valores.
          for (let entry of this.ingredients.providers) {
            //Recuperamos los valores del providers a tratar
            await this.providersServices.firestore.collection('providers').doc(entry.uid).get().then(doc => {
              var v = doc.data();
              var _array = Array();
              _array.push(entry.uid);
              _array.push(v.name);
              _array.push(v.nif);
              _array.push(v.address);
              _array.push(v.province);
              _array.push(v.city);
              _array.push(v.phone);
              _array.push(v.country);
              _array.push(v.email);
              _array.push(v.contact_name);
              _array.push(entry.default);//default
              _array.push(entry.price_static);//price_notax
              _array.push(entry.tax_static);//tax
              _array.push(entry.pricetotal_static);//price
              this.providersServices.providers_array_tmp.push(_array);
            });
            const providersRef = this.firestore.collection('providers');
            //Buscamos por ads_provider_uid para los proveedores que son añadidos desde ads
            providersRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_provider_uid', '==', entry.uid).get()
              .then(snapshot => {
                snapshot.forEach(doc => {
                  var v = doc.data();
                  var _array = Array();
                  _array.push(entry.uid);
                  _array.push(v.name);
                  _array.push(v.nif);
                  _array.push(v.address);
                  _array.push(v.province);
                  _array.push(v.city);
                  _array.push(v.phone);
                  _array.push(v.country);
                  _array.push(v.email);
                  _array.push(v.contact_name);
                  _array.push(entry.default);//default
                  _array.push(entry.price_static);//price_notax
                  _array.push(entry.tax_static);//tax
                  _array.push(entry.pricetotal_static);//price
                  this.providersServices.providers_array_tmp.push(_array);
                });
              });
          }
        }
      }
    } else {
      this.providersServices.providers_array_tmp = Array();
      this.providers = Array();
      //insert
      var _array = Array();
      _array.push(this.globals.no_provider.UID);
      _array.push(this.globals.no_provider.name);
      _array.push(this.globals.no_provider.nif);
      _array.push(this.globals.no_provider.address);
      _array.push(this.globals.no_provider.province);
      _array.push(this.globals.no_provider.city);
      _array.push(this.globals.no_provider.phone);
      _array.push(this.globals.no_provider.country);
      _array.push(this.globals.no_provider.email);
      _array.push(this.globals.no_provider.contact_name);
      _array.push(true);//default
      _array.push(0);//price_notax
      _array.push(0);//tax
      _array.push(0);//price
      this.providersServices.providers_array_tmp.push(_array);
    }
    this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];
  }
  searchProvidersNode(value, type) {
    this.providersServices.providersSearch(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-select-provider/ingredient-create-select-provider.ts